module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (10).baaf008b.jpg";